// @ts-check

const baseUrl = import.meta.env.VITE_SOCKET_URL;

/**
 * @typedef {{ name: string, publisher?: string, issn?: string, source: string, url?: string }} JournalResult
 */

/**
 * Search for journals across Semantic Scholar, CrossRef, and PubMed NCBI.
 * @param {string} query
 * @param {string | null | undefined} userToken
 * @param {{ signal?: AbortSignal }} [options]
 * @returns {Promise<JournalResult[]>}
 */
export async function searchJournals(query, userToken, { signal } = {}) {
  if (!query || query.trim().length < 2) return [];

  const url = new URL(`journals/search`, baseUrl);
  url.searchParams.set("q", query.trim());

  let response;
  try {
    response = await fetch(url.href, {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      signal,
    });
  } catch (error) {
    if (error?.name === "AbortError") throw error;
    throw new Error("Journal search could not reach the server. Check your connection, or type the journal name yourself.", { cause: error });
  }

  if (!response.ok) {
    throw new Error(`Journal search failed: ${response.status}`);
  }

  const data = await response.json();
  return data.journals ?? [];
}
